import React from 'react';
import styled from 'astroturf/react';

const TINY_SCREEN_SIZE = 630;

const UpsellTextBox = styled.div`
  display: flex;
  flex-direction: column;
`;
const UpsellTitle = styled.div<{
  preview: boolean;
  text_align_center: boolean;
  text_align_left: boolean;
}>`
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 20px;

  &.text_align_center {
    text-align: center;
  }

  &.text_align_left {
    text-align: left;
  }

  &.preview {
    font-weight: 500;
  }
`;
const ProductFeatureLine = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: baseline;
`;
const ProductCheckmark = styled.i`
  margin-right: 8px;
`;
const ProductFeatureText = styled.div`
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;

  @media (max-width: ${TINY_SCREEN_SIZE}px) {
    font-size: 14px !important;
  }
`;

interface Props {
  withPreview: boolean;
  textAlignment?: 'center' | 'left';
}

const TranslationFeaturesText: React.FC<Props> = ({
  withPreview,
  textAlignment = 'left',
}): React.ReactElement => {
  return (
    <UpsellTextBox>
      <UpsellTitle
        preview={withPreview}
        text_align_center={textAlignment === 'center'}
        text_align_left={textAlignment === 'left'}
      >
        Get Unlimited Translations with Academia Premium
      </UpsellTitle>
      <ProductFeatureLine>
        <ProductCheckmark
          style={{ color: withPreview ? '#5C7FB9' : '#91A6CA' }}
          className="fa fa-check"
        />
        <ProductFeatureText style={{ fontSize: withPreview ? '15px' : '18px' }}>
          Download translated PDFs in 24 different languages
        </ProductFeatureText>
      </ProductFeatureLine>
      <ProductFeatureLine>
        <ProductCheckmark
          style={{ color: withPreview ? '#5C7FB9' : '#91A6CA' }}
          className="fa fa-check"
        />
        <ProductFeatureText style={{ fontSize: withPreview ? '15px' : '18px' }}>
          Unlimited translations of millions of papers on Academia
        </ProductFeatureText>
      </ProductFeatureLine>
      <ProductFeatureLine>
        <ProductCheckmark
          style={{ color: withPreview ? '#5C7FB9' : '#91A6CA' }}
          className="fa fa-check"
        />
        <ProductFeatureText style={{ fontSize: withPreview ? '15px' : '18px' }}>
          Get the papers you need no matter the language
        </ProductFeatureText>
      </ProductFeatureLine>
    </UpsellTextBox>
  );
};

export default TranslationFeaturesText;
